// Garden of Eden's static spell-draw cap: "Players can't draw more than
// one spell each turn."
//
// Static presence rule. While ANY card carrying the LIMIT_SPELL_DRAWS
// op is in play, a player's 2nd+ SPELL draw this turn is blocked. Only
// Spellbook draws count as spell draws (Atlas draws are sites, not
// spells). Affects every player ("Players can't..."). Per-turn counts
// reset at turn start; the choke point (cardPileLifecycle.drawCard)
// owns the counter and consults these pure predicates before each
// Spellbook draw.

import { OP } from '../schema';

/**
 * True if any in-play card's automation carries the spell-draw cap.
 * @param {Map} meshes        live mesh map
 * @param {(id:string)=>object} getFullCard catalog lookup by cardId
 */
export function spellDrawCapActive(meshes, getFullCard) {
  if (!meshes || typeof meshes[Symbol.iterator] !== 'function' || !getFullCard) return false;
  for (const [, mesh] of meshes) {
    const card = mesh?.userData?.cardInstance;
    if (!card) continue;
    const fullCard = getFullCard(card.cardId);
    const entries = fullCard?.automation || [];
    if (entries.some((e) => (e.effect || []).some((eff) => eff.op === OP.LIMIT_SPELL_DRAWS))) {
      return true;
    }
  }
  return false;
}

/**
 * True if this Spellbook draw must be blocked: the cap is active AND the
 * drawer has already taken at least `limit` spell draws this turn.
 * @param {number} spellDrawsThisTurn count BEFORE this draw
 * @param {boolean} capActive         spellDrawCapActive(...) result
 * @param {number} limit              max spell draws per turn (default 1)
 */
export function isSpellDrawBlocked(spellDrawsThisTurn, capActive, limit = 1) {
  return capActive && spellDrawsThisTurn >= limit;
}
